import React from "react";
import { graphql } from "gatsby";
import Page from "../components/Page";
import Project from "../templates/project-template";

const Projects = ({ data }) => {
  const { edges } = data.allMarkdownRemark;

  return (
    <Page>
      {edges.map(edge => (
        <Project key={edge.node.id} data={edge.node.frontmatter} />
      ))}
    </Page>
  );
};

export const query = graphql`
  query Projects {
    allMarkdownRemark(
      filter: { frontmatter: { template: { eq: "post" }, draft: { ne: true } } }
      sort: { order: DESC, fields: [frontmatter___date] }
    ) {
      edges {
        node {
          id
          frontmatter {
            title
            description
            thumbnail
            tags
            github
            live
          }
        }
      }
    }
  }
`;

export default Projects;
